module.exports = __webpack_public_path__ + "img/logo.66a6b3ad.png";